/* F1 Museum: lazy glow videos, circuit picker + collector tray, trio button, buy-box add-ons. Loaded deferred on the two F1 templates only. */
(function () {
  if (window.ssF1) return;
  window.ssF1 = 1;

  // constants.js / pubsub.js declare these with const/function at top level: reachable by name, not on window
  var EV = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
  var sub = typeof subscribe === 'function' ? subscribe : null;
  var pub = typeof publish === 'function' ? publish : null;

  var FREE = 200000; // keep in step with the automatic discount "Free Shipping over EGP2,000"

  function money(cents, fmt) {
    var n = cents / 100;
    var s = (cents % 100 ? n.toFixed(2) : String(Math.round(n))).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || 'LE {{amount}}').replace(/\{\{\s*\w+\s*\}\}/, s);
  }

  function add(items) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function (j) {
        if (drawer && j.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(j);
          if (pub && EV) pub(EV.cartUpdate, { source: 'ss-f1', cartData: j });
        } else {
          window.location.href = '/cart';
        }
        return j;
      });
  }

  function busy(btn, on) { if (btn) { btn.classList.toggle('is-busy', on); btn.setAttribute('aria-busy', on ? 'true' : 'false'); } }

  /* ---------- lazy, in-view-only videos ---------- */
  var vids = document.querySelectorAll('video.f1-lazyvid, .f1-lazyvid video');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          v.muted = true;
          v.dataset.loaded = '1';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (v.dataset.loaded) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- circuit picker + collector tray ---------- */
  document.querySelectorAll('[data-f1-grid]').forEach(function (grid) {
    var fmt = grid.dataset.fmt;
    var tray = document.querySelector('[data-f1-tray="' + grid.id + '"]');
    var size = '30';

    function cards() { return grid.querySelectorAll('[data-f1-card]'); }
    function variant(card) { try { return JSON.parse(card.getAttribute('data-v' + size)); } catch (e) { return null; } }

    function paint() {
      cards().forEach(function (card) {
        var v = variant(card);
        var box = card.querySelector('[data-f1-pick]');
        var now = card.querySelector('[data-f1-now]');
        var was = card.querySelector('[data-f1-was]');
        var low = card.querySelector('[data-f1-low]');
        var link = card.querySelectorAll('[data-f1-link]');
        var ok = !!(v && v.a);
        card.classList.toggle('is-out', !ok);
        if (box) {
          box.disabled = !ok;
          if (!ok) box.checked = false;
          var off = box.parentNode.querySelector('.is-off');
          if (off) off.textContent = ok ? (box.dataset.label || '+ Add to my grid') : 'Sold out';
        }
        if (v) {
          if (now) now.textContent = money(v.p, fmt);
          if (was) { was.textContent = v.c > v.p ? money(v.c, fmt) : ''; was.hidden = !(v.c > v.p); }
          if (low) { low.hidden = !(ok && v.q > 0 && v.q <= 3); low.textContent = v.q === 1 ? 'Last one' : 'Only ' + v.q + ' left'; }
          link.forEach(function (a) { a.href = a.href.split('?')[0] + '?variant=' + v.id; });
        }
        card.classList.toggle('is-picked', !!(box && box.checked));
      });
      sum();
    }

    function picked() {
      var out = [];
      cards().forEach(function (card) {
        var box = card.querySelector('[data-f1-pick]');
        var v = variant(card);
        if (box && box.checked && v && v.a) out.push(v);
      });
      return out;
    }

    function sum() {
      if (!tray) return;
      var list = picked();
      var total = list.reduce(function (t, v) { return t + v.p; }, 0);
      var was = list.reduce(function (t, v) { return t + Math.max(v.c, v.p); }, 0);
      tray.classList.toggle('is-on', list.length > 0);
      tray.querySelector('[data-f1-sum]').innerHTML = money(total, fmt) + (was > total ? ' <s>' + money(was, fmt) + '</s>' : '');
      tray.querySelector('[data-f1-go]').textContent = 'Add ' + list.length + ' to cart';
      var note = tray.querySelector('[data-f1-note]');
      var left = FREE - total;
      note.innerHTML = left > 0
        ? money(left, fmt) + ' more for free delivery &middot; or pay online: always free'
        : '<b>Free delivery unlocked</b> &middot; pay on delivery or online';
      tray.querySelector('[data-f1-bar]').style.width = Math.min(100, Math.round((total / FREE) * 100)) + '%';
    }

    grid.addEventListener('change', function (e) {
      if (e.target.name === grid.id + '-size') { size = e.target.value; }
      paint();
    });

    if (tray) {
      var btn = tray.querySelector('[data-f1-go]');
      btn.addEventListener('click', function () {
        var list = picked();
        if (!list.length) return;
        busy(btn, true);
        add(list.map(function (v) { return { id: v.id, quantity: 1 }; }))
          .then(function () {
            grid.querySelectorAll('[data-f1-pick]:checked').forEach(function (b) { b.checked = false; });
            paint();
          })
          .catch(function (err) { tray.querySelector('[data-f1-note]').textContent = err.message; })
          .finally(function () { busy(btn, false); });
      });
    }
    paint();
  });

  /* ---------- one-click sets (trio) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-f1-add]');
    if (!btn) return;
    e.preventDefault();
    var ids = btn.getAttribute('data-f1-add').split(',').filter(Boolean);
    busy(btn, true);
    add(ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }))
      .catch(function (err) { window.alert(err.message); })
      .finally(function () { busy(btn, false); });
  });

  /* ---------- per-variant lines (savings, stock) in custom buy-box blocks ---------- */
  function showVariant(id) {
    document.querySelectorAll('[data-f1-variant]').forEach(function (el) {
      el.hidden = String(el.getAttribute('data-f1-variant')) !== String(id);
    });
  }
  if (sub && EV) {
    sub(EV.variantChange, function (ev) {
      var v = ev && ev.data && ev.data.variant;
      if (v) showVariant(v.id);
      document.dispatchEvent(new CustomEvent('f1:variant'));
    });
  }

  /* ---------- product buy box: "complete the grid" add-ons ---------- */
  var box = document.querySelector('[data-f1-addons]');
  if (box) {
    var fmt = box.dataset.fmt;
    var prices = {};
    try { prices = JSON.parse(box.dataset.prices); } catch (e) {}
    var totalEl = box.querySelector('[data-f1-total]');

    function mainForm() { return document.querySelector('form[data-type="add-to-cart-form"]'); }
    function mainVariant() { var f = mainForm(); var i = f && f.querySelector('[name=id]'); return i ? i.value : null; }
    function mainQty() { var q = document.querySelector('.product-form__quantity input[name=quantity], input[name=quantity][form]'); return Math.max(1, parseInt(q && q.value, 10) || 1); }

    function total() {
      var ticks = box.querySelectorAll('input[data-spk-addon]:checked');
      if (!totalEl) return;
      if (!ticks.length) { totalEl.hidden = true; return; }
      var t = (prices[mainVariant()] || 0) * mainQty();
      ticks.forEach(function (i) { t += parseInt(i.dataset.price, 10) || 0; });
      var n = ticks.length + mainQty();
      totalEl.hidden = false;
      totalEl.innerHTML = '<span>' + n + ' circuits in one parcel</span><b>' + money(t, fmt) + '</b>' + (t >= FREE ? '<em>Free delivery unlocked</em>' : '<span>' + money(FREE - t, fmt) + ' to free delivery</span>');
    }
    document.addEventListener('change', total);
    document.addEventListener('input', total);
    document.addEventListener('f1:variant', total);
    total();

    // product-form.js adds ticked boxes in the same request; untick once they are in the cart
    if (sub && EV) {
      sub(EV.cartUpdate, function (ev) {
        if (ev && ev.source !== 'product-form') return;
        box.querySelectorAll('input[data-spk-addon]:checked').forEach(function (i) { i.checked = false; });
        total();
      });
    }

    // "Buy it now" skips product-form.js: add main + ticked add-ons, then go to checkout
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.shopify-payment-button__button');
      var ticks = box.querySelectorAll('input[data-spk-addon]:checked');
      if (!b || !ticks.length || window.ssF1Bypass) return;
      var id = parseInt(mainVariant(), 10);
      if (!id) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var items = [{ id: id, quantity: mainQty() }];
      ticks.forEach(function (i) { items.push({ id: parseInt(i.dataset.variantId, 10), quantity: 1 }); });
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/checkout'; })
        .catch(function () { window.ssF1Bypass = true; b.click(); });
    }, true);
  }
})();
